import React from 'react'
import Carousel from './Carousel'
import pro11 from '../images/anime/1.png'
import pro12 from '../images/anime/2.png'
import pro13 from '../images/anime/3.png'
import pro21 from '../images/news/1.png'
import pro22 from '../images/news/2.png'
import pro23 from '../images/news/3.png'
import pro31 from '../images/textutil/1.png'
import pro32 from '../images/textutil/2.png'
import pro33 from '../images/textutil/3.png'
import pro41 from '../images/spotify/1.png'
import pro42 from '../images/spotify/2.png'
import pro51 from '../images/weather/1.png'
import pro52 from '../images/weather/2.png'
import pro53 from '../images/weather/3.png'
import pro61 from '../images/fileshare/1.png'
import pro62 from '../images/fileshare/2.png'
import pro63 from '../images/fileshare/3.png'
import pro71 from '../images/blocker/1.png'
import pro72 from '../images/blocker/2.png'
import pro81 from '../images/blog/1.png'
import pro82 from '../images/blog/2.png'
import pro83 from '../images/blog/3.png'
import pro84 from '../images/blog/4.png'
import pro85 from '../images/blog/5.png'
function Projects() {
  return (
    <div>
      <div className='font-light text-4xl md:text-6xl flex justify-center mt-[35px] md:mt-[100px]'>Projects</div>
      <Carousel imgs={[pro61,pro62,pro63]} gray={true} title="FileShare App" para="File Share app  allows its users to share their files across internet every file have a key through which file can be shared." keywords={['Reactjs', 'Firebase','storage','Material UI', 'tailwind']} link="https://glittery-dragon-3d594d.netlify.app/"/>
      <Carousel imgs={[pro81,pro82,pro83,pro84,pro85]} gray={false} title="Health Blog App" para="Health blog provides it users with the most effective way to live a health life in there busy schedule of their daily life. this blogs not only provides blog but also allows its users to write their blogs and share thier secrets for being healthy to others." keywords={['Html', 'Javascript','Nodejs','heroku', 'mongoDB', 'Express js']} link="https://fast-cliffs-64668.herokuapp.com/"/>
      <Carousel imgs={[pro51,pro52,pro53]} gray={true} title="Weather App" para="Weather app is a weather webApplication which allows its user to know the weather of there desired city" keywords={['Reactjs', 'Weather Api','Material UI', 'tailwind']} link="https://aquamarine-rugelach-92097b.netlify.app/"/>
      <Carousel imgs={[pro71,pro72]} gray={false} title="Social media Blocker extension" para="Social media blocker when activated blocks all the social media websites such as youtube and netflix so that user cannot be disracted while doing their work." keywords={['javascript']} link="https://github.com/visha064/blocker"/>
    <Carousel imgs={[pro11,pro12,pro13]} gray={true} title="Anime App" para="Anime App is a website which shows the the most popular anime and manga to date and allows user to sign up and bookmark there favourite anime and manga" keywords={['Reactjs', 'firebase', 'firestore', 'Material UI', 'tailwind']} link=""/>
   <Carousel imgs={[pro21,pro22,pro23]} gray={false} title="News App" keywords={['Reactjs', 'Bootstrap', 'NewsApi']} para="News webApp is a website at which you can get to know the latest news across the world and you can choose to read in which you are interseted like science, sports, bussiness" link="https://github.com/visha064/newsapp"/>
   <Carousel imgs={[pro31,pro32,pro33]} gray={true} title="Textutils"
   para="Textutils is an Web Application which allows its user to change their textx to their desired test" 
    keywords={['Reactjs', 'Bootstrap']}
    link="https://visha064.github.io/textutils/"
   />
   <Carousel imgs={[pro41,pro42]} gray={false} title="Spotify"
   para="Spotify allows the user to listen to their music "
    keywords={['Html', 'CSS', 'Javascript']}
    link="https://visha064.github.io/spotify/"
   />
    </div>
  )
}

export default Projects
